export const onEditProject = project => ({
  widget: 'projects',
  type: 'onEditProject',
  payload: { project },
})



// WEBPACK FOOTER //
// ./src/projects/actions/onEditProject.js